import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GlButton from '@/components/gl-button';
export default {
  components: {
    GlButton: GlButton
  },
  methods: {
    // 账号登录
    handleLogin: function handleLogin() {
      // 注册企业埋点
      this.$ga.event('FHRLogin', 'click', 'TeamCreation', 6);
      this.$router.push({
        path: '/register/team'
      });
    }
  }
};